import { Stack, Group, Text, Box } from '@repletoryreach/sdk-ui';
import type { admin } from '@repletoryreach/sdk-api';
import { formatDateTime } from '../../../../lib/format';
import { TenantName } from '../../../../components/TenantName';
import { CopyableId } from '../../../../components/CopyableId';
import { EntryTypeBadge, Money, entryTypeOf } from '../../components/cells';
import { useT } from '../../../../i18n/I18nProvider';

type Entry = NonNullable<Awaited<ReturnType<typeof admin.listLedger>>['data']>[number];

/**
 * The narrow-screen reading of the same journal: what was charged, to whom and
 * when on the left, the amount on the right in the colour of its direction.
 */
export function LedgerList({ records }: { records: Entry[] }) {
  const t = useT();
  return (
    <Stack gap="xs">
      {records.map((e) => (
        <div key={e.id} className="rr-list-row" style={{ cursor: 'default' }}>
          <Group gap="md" align="center" wrap="nowrap" style={{ width: '100%' }}>
            <Stack gap="xs" style={{ flex: 1, minWidth: 0 }}>
              <Group gap="xs" align="baseline" wrap="nowrap">
                <EntryTypeBadge type={entryTypeOf(e)} />
                <Text role="subtitle" fw={600} truncate>
                  {e.sku_code ? <code>{e.sku_code}</code> : t('billing.ledger.type.adjustment')}
                </Text>
                {e.description && (
                  <Text role="caption" c="var(--rr-color-text-muted)" truncate>{e.description}</Text>
                )}
              </Group>
              <Group gap="xs" align="center" wrap="nowrap">
                <TenantName id={e.organisation_id} subtle />
                <span title={e.occurred_at}>
                  <Text role="caption" c="var(--rr-color-text-muted)">· {formatDateTime(e.occurred_at)}</Text>
                </span>
                {e.idempotency_key && <CopyableId value={e.idempotency_key} label={t('billing.ledger.copyReference')} />}
              </Group>
            </Stack>
            <Box style={{ minWidth: 130, textAlign: 'right' }}>
              <Money minor={e.amount_minor} currency={e.currency} signed />
            </Box>
          </Group>
        </div>
      ))}
    </Stack>
  );
}
